module.exports = __webpack_public_path__ + "img/trial1-2.6e98d46f.png";